export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'defaultImageUrl',
    width: 80,
    title: that.$l('INDEX.table_label_image') || '图片',
    headerAlign: 'left',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('table_label_specName') || '规格名称',
    field: 'specName',
    minWidth: 240,
    align: 'left',
    fixed: 'left',
    slots: { default: 'specName' },
  },
  {
    title: that.$l('table_label_productName') || '产品名称',
    field: 'productName',
    minWidth: 240,
    align: 'left',
    slots: { default: 'productName' },
  },
  {
    title: that.$l('table_label_standardSizes') || '规格尺寸',
    field: 'specSize',
    minWidth: 160,
    align: 'left',
  },
  {
    title: that.$l('table_label_productSpecUnit') || '单品规格数量',
    field: 'specQty',
    minWidth: 80,
    align: 'left',
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totalSpecQuantity') || '总规格数量',
    field: 'subSpecInContainerQty',
    minWidth: 150,
    headerAlign: 'left',
    isTotalColumn: true,
    align: 'left',
    formatter: ({ cellValue }) => that.format(cellValue),
  },
]
